import { GET_REPORT_API, SCHEDULE_REPORT_API } from "./constants";

const buildHeaders = (accessToken) => ({
  Authorization: `Bearer ${accessToken}`,
  "Content-Type": "application/json",
});

export const submitScheduleReport = async ({ accessToken, payload }) => {
  const res = await fetch(SCHEDULE_REPORT_API, {
    method: "POST",
    headers: buildHeaders(accessToken),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to submit schedule report");
  return data;
};

export const fetchScheduleReports = async ({ accessToken, campaignId }) => {
  const res = await fetch(
    `${GET_REPORT_API}?campaign_id=${encodeURIComponent(campaignId.trim())}`,
    {
      method: "GET",
      headers: buildHeaders(accessToken),
    }
  );
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to fetch schedule reports");
  return data;
};
